var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "121.225px",
    height: "27.417px",
    viewBox: "0 0 121.225 27.417",
    enableBackground: "new 0 0 121.225 27.417",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E5DC",
    d: "M63.976,25.842c-34.081,0-58.771-14.193-59.806-14.797C1.398,9.426,1.283,4.73,3.914,3.024 c2.625-1.703,6.999,0.225,9.771,1.836l0,0C13.9,4.985,35.536,17.325,63.976,17.325c27.93,0,42.637-11.805,42.781-11.925 c2.295-1.881,6.631-4.264,9.688-2.851c3.057,1.41,3.676,6.08,1.383,7.962C117.065,11.136,98.747,25.842,63.976,25.842z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompSmile);
export default __webpack_public_path__ + "static/media/comp_smile.6393ebe2332e8aa84dfb832a1f779b4b.svg";
export { ForwardRef as ReactComponent };